import { parseUtcAsLocal } from "app/shared/utils/date-utils";

export class AppVersion {
  Id: number;
  AppType: string;
  VersionNumber: string;
  ReleaseDate: Date | null;
  RequiredUpdate: boolean;
  CurrentVersion: boolean;
  MinVersion: string;

  get Released(): string {
    return this.ReleaseDate ? (this.ReleaseDate.toLocaleDateString() +  ' ' +this.ReleaseDate.toLocaleTimeString()) : '';
  }
 
  constructor(data?: Partial<AppVersion>) {
    Object.assign(this, data);
    if (data?.ReleaseDate) {
      this.ReleaseDate = parseUtcAsLocal(data.ReleaseDate);
    }
  }
}